import { render, staticRenderFns } from "./ArmyType.vue?vue&type=template&id=2642ee53"
import script from "./ArmyType.vue?vue&type=script&lang=js"
export * from "./ArmyType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports